import api from './api';

const state = {
	error: null,
	violations: [],
};

const getters = {};

const mutations = {
	setError(state, { error }) {
		state.error = error;
	},

	setViolations(state, violations) {
		state.violations = violations;
	},
};

const actions = {
	async load({ commit }) {
		try {
			const violations = (await api.list()).data;
			commit('setViolations', violations);
		} catch (err) {
			commit('setError', { error: err.response.data.message });
		}
	},

	clearError({ commit }) {
		commit('setError', { error: null });
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
